export default __webpack_public_path__ + "static/media/icon-github.6d729388.svg";